"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNarrowedDeviceModelInternal = void 0;
const deviceModelInternal_1 = require("./deviceModelInternal");
const getNarrowedDeviceModelInternal = (model) => (model === deviceModelInternal_1.DeviceModelInternal.T2B1 ? deviceModelInternal_1.DeviceModelInternal.T3B1 : model);
exports.getNarrowedDeviceModelInternal = getNarrowedDeviceModelInternal;
//# sourceMappingURL=deviceModelInternalUtils.js.map